module.exports = __webpack_public_path__ + "img/gal_32.728660dd.png";